import { useQuery } from '@tanstack/react-query';
import { DashboardFolderT } from 'business/definitions';
import { RQAPICallWithData } from 'store/APIClient';

/**
 * Fetches the dashboard folders.
 */
export const useGetDashboardFolders = () =>
    useQuery({
        queryKey: ['dashboard_folders'],

        queryFn: async () => {
            const response = await RQAPICallWithData<DashboardFolderT[]>({
                endpoint: 'explore/dashboard_folders',
                method: 'GET',
            });
            return response.content.data;
        },
    });
